import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";

type RevisionConflictProps = {
	onClose: () => void;
	open: boolean;
};

export const RevisionConflict = ({ open, onClose }: RevisionConflictProps) => {
	const [t, texts] = useText();

	return (
		<Dialog
			isDismissable={false}
			size="small"
			isOpen={open}
			heading={t(texts.error.modal.revisionConflict.title)}
		>
			<Dialog.Content>{t(texts.error.modal.revisionConflict.body)}</Dialog.Content>
			<ButtonGroup>
				<Button
					onPress={() => {
						onClose();
						window.location.reload();
					}}
				>
					{t(texts.error.modal.revisionConflict.reload)}
				</Button>
				<Button variant="secondary" onPress={onClose}>
					{t(texts.error.modal.revisionConflict.close)}
				</Button>
			</ButtonGroup>
		</Dialog>
	);
};
